import { render, staticRenderFns } from "./LibraryPublishButtons.vue?vue&type=template&id=4ba5145d&scoped=true&"
import script from "./LibraryPublishButtons.vue?vue&type=script&lang=js&"
export * from "./LibraryPublishButtons.vue?vue&type=script&lang=js&"
import style0 from "./LibraryPublishButtons.vue?vue&type=style&index=0&id=4ba5145d&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ba5145d",
  null
  
)

export default component.exports